import { render, staticRenderFns } from "./UnifiedLayout.vue?vue&type=template&id=18d99ed2&scoped=true&"
import script from "./UnifiedLayout.vue?vue&type=script&lang=ts&"
export * from "./UnifiedLayout.vue?vue&type=script&lang=ts&"
import style0 from "./UnifiedLayout.vue?vue&type=style&index=0&id=18d99ed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d99ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
